export const UTM_COOKIE = 'utm';
export const UTM_COOKIE_MAX_AGE_SECONDS = 60 * 60 * 24 * 30;

const UTM_MAX_VALUE_LENGTH = 256;

const UTM_HEADERS = {
  utm_source: 'X-UTM-Source',
  utm_medium: 'X-UTM-Medium',
  utm_campaign: 'X-UTM-Campaign',
  utm_term: 'X-UTM-Term',
  utm_content: 'X-UTM-Content',
  utm_id: 'X-UTM-ID',
} as const;

type UtmParam = keyof typeof UTM_HEADERS;

const UTM_PARAMS = Object.keys(UTM_HEADERS) as UtmParam[];

export function extractUtmCookieValue(searchParams: URLSearchParams): string | null {
  const result = new URLSearchParams();

  for (const param of UTM_PARAMS) {
    const value = searchParams.get(param)?.trim();
    if (value) result.set(param, value.slice(0, UTM_MAX_VALUE_LENGTH));
  }

  return result.size ? result.toString() : null;
}

const isHeaderSafe = (value: string) => /^[\x20-\x7E]*$/.test(value);

export function getUtmHeaders(cookieValue: string | undefined): Record<string, string> {
  if (!cookieValue) return {};

  const params = new URLSearchParams(cookieValue);
  const headers: Record<string, string> = {};

  for (const param of UTM_PARAMS) {
    const value = params.get(param)?.trim();
    if (!value) continue;
    headers[UTM_HEADERS[param]] = isHeaderSafe(value) ? value : encodeURIComponent(value);
  }

  return headers;
}
